import { render, staticRenderFns } from "./FaAngleLeft.vue?vue&type=template&id=52e0a02e"
import script from "./FaAngleLeft.vue?vue&type=script&lang=ts"
export * from "./FaAngleLeft.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports